import React from 'react'

import { useTranslation } from "react-i18next";

import "./MouseScroll.css"

const MouseScroll = () => {
  const { t } = useTranslation();

  return (
    <div class="mouse_scroll">
        <p class="m_scroll_text">{t("mouse_scroll")}</p>
        <div class="mouse">
            <div class="wheel"></div>
        </div>
        <div className='justify-self-center'>
            <span class="m_scroll_arrows unu"></span>
            <span class="m_scroll_arrows doi"></span>
            <span class="m_scroll_arrows trei"></span>
        </div>
    </div>
  )
}

export default MouseScroll;